module.exports = __webpack_public_path__ + "static/recommend-67cc426a0b68aabf3f421018ee950bfb.svg";